/**
 * Default time skew time to check if the token has expired
 * @type {number}
 */
// eslint-disable-next-line no-magic-numbers
export const CLOCK_SKEW_TIME: number = 5 * 60000;
/**
 * List of parameters required in the redirect callback that you get from TID
 * @type {Array<string>}
 */
export const LIST_PARAMS_REQUIRED: Array<string> = ['code', 'state'];
